/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export { ApiError } from './core/ApiError';
export { CancelablePromise, CancelError } from './core/CancelablePromise';
export { OpenAPI } from './core/OpenAPI';
export type { OpenAPIConfig } from './core/OpenAPI';

export type { AboutEstateInfo } from './models/AboutEstateInfo';
export type { AcceptedPreview } from './models/AcceptedPreview';
export type { Address } from './models/Address';
export type { AddressDto } from './models/AddressDto';
export type { AppointmentModel } from './models/AppointmentModel';
export type { AreaTagDto } from './models/AreaTagDto';
export type { AssessDto } from './models/AssessDto';
export type { AssessmentDto } from './models/AssessmentDto';
export type { AssessValueDto } from './models/AssessValueDto';
export type { AssociationDto } from './models/AssociationDto';
export type { AuthMessage } from './models/AuthMessage';
export type { AuthReference } from './models/AuthReference';
export type { AuthToken } from './models/AuthToken';
export type { AutoCompleteArea } from './models/AutoCompleteArea';
export type { AutoCompleteCounty } from './models/AutoCompleteCounty';
export type { AutoCompleteMunicipality } from './models/AutoCompleteMunicipality';
export type { BalconyPatioDto } from './models/BalconyPatioDto';
export type { BidDto } from './models/BidDto';
export { BidSetting } from './models/BidSetting';
export type { BookableTimeSlotModel } from './models/BookableTimeSlotModel';
export type { BrokerDto } from './models/BrokerDto';
export type { BrokerImageModel } from './models/BrokerImageModel';
export type { BuildingDto } from './models/BuildingDto';
export type { BuyerOnObject } from './models/BuyerOnObject';
export type { CommercialFloorAndElevatorDto } from './models/CommercialFloorAndElevatorDto';
export type { CommercialInfoDto } from './models/CommercialInfoDto';
export type { CommercialPropertyBuildingDto } from './models/CommercialPropertyBuildingDto';
export type { CompletionDataUser } from './models/CompletionDataUser';
export type { ConsentAnswerDto } from './models/ConsentAnswerDto';
export type { ConsentTextDto } from './models/ConsentTextDto';
export type { ConsentVersionDto } from './models/ConsentVersionDto';
export type { Contact } from './models/Contact';
export type { ContactLink } from './models/ContactLink';
export type { ContractDeclineModel } from './models/ContractDeclineModel';
export type { CreateConsentDto } from './models/CreateConsentDto';
export type { DateListDto } from './models/DateListDto';
export type { DescriptionDto } from './models/DescriptionDto';
export type { DocumentDto } from './models/DocumentDto';
export type { Documents } from './models/Documents';
export type { DownPayment } from './models/DownPayment';
export type { EconomyBuildingDto } from './models/EconomyBuildingDto';
export type { EconomyInfo } from './models/EconomyInfo';
export type { EditUserRequest } from './models/EditUserRequest';
export type { ElectricityDto } from './models/ElectricityDto';
export type { EnergyDeclarationDto } from './models/EnergyDeclarationDto';
export type { EnrollmentsDto } from './models/EnrollmentsDto';
export type { EstateCardDto } from './models/EstateCardDto';
export { EstateClassType } from './models/EstateClassType';
export type { EstateDto } from './models/EstateDto';
export type { EstateListMapResultModel } from './models/EstateListMapResultModel';
export type { EstateListResultModel } from './models/EstateListResultModel';
export type { EstateMapDto } from './models/EstateMapDto';
export type { EstateOfficeDto } from './models/EstateOfficeDto';
export { EstateType } from './models/EstateType';
export type { EstateTypeTagDto } from './models/EstateTypeTagDto';
export type { ExtraSearchCriteriaTagDto } from './models/ExtraSearchCriteriaTagDto';
export type { Facebook } from './models/Facebook';
export type { FarmBuildingDto } from './models/FarmBuildingDto';
export type { FieldValueCriteria } from './models/FieldValueCriteria';
export type { FilterEstateTags } from './models/FilterEstateTags';
export type { FinalPayment } from './models/FinalPayment';
export { Fit } from './models/Fit';
export type { Foursquare } from './models/Foursquare';
export type { GeneralInfo } from './models/GeneralInfo';
export type { Google } from './models/Google';
export type { HomeAssignmentLoan } from './models/HomeAssignmentLoan';
export type { ILocationData } from './models/ILocationData';
export type { ImageDto } from './models/ImageDto';
export type { Images } from './models/Images';
export type { IncludedInFeeDto } from './models/IncludedInFeeDto';
export type { InsuranceDto } from './models/InsuranceDto';
export { InterestLevel } from './models/InterestLevel';
export type { InterestOnObject } from './models/InterestOnObject';
export type { Item } from './models/Item';
export type { Items } from './models/Items';
export type { KycForm } from './models/KycForm';
export type { KycFormResponse } from './models/KycFormResponse';
export type { KycStatus } from './models/KycStatus';
export type { LinkDto } from './models/LinkDto';
export type { Loan } from './models/Loan';
export type { Location } from './models/Location';
export type { MainResidentialBuildingDto } from './models/MainResidentialBuildingDto';
export type { MaintenanceAndRebuilding } from './models/MaintenanceAndRebuilding';
export type { MortageDto } from './models/MortageDto';
export type { MunicipalityTagDto } from './models/MunicipalityTagDto';
export type { MyEstateDto } from './models/MyEstateDto';
export type { MyPagesEstateDto } from './models/MyPagesEstateDto';
export type { MyPagesValueCheckFormViewModel } from './models/MyPagesValueCheckFormViewModel';
export type { Network } from './models/Network';
export type { OfficeBlockDto } from './models/OfficeBlockDto';
export type { OfficeDropDownDto } from './models/OfficeDropDownDto';
export type { OfficeDto } from './models/OfficeDto';
export type { OfficeLiteDto } from './models/OfficeLiteDto';
export type { OfficeSearchDto } from './models/OfficeSearchDto';
export type { OfficeSearchResult } from './models/OfficeSearchResult';
export type { OGMetaEstate } from './models/OGMetaEstate';
export type { OpenHours } from './models/OpenHours';
export type { OpeningHourDetails } from './models/OpeningHourDetails';
export type { OpeningHourSpan } from './models/OpeningHourSpan';
export type { OperationDto } from './models/OperationDto';
export type { OtherResidentialBuildingDto } from './models/OtherResidentialBuildingDto';
export type { ParticipationAndRepairFundDto } from './models/ParticipationAndRepairFundDto';
export type { Person } from './models/Person';
export type { PersonDataDto } from './models/PersonDataDto';
export type { PinMeToContact } from './models/PinMeToContact';
export type { Polygon } from './models/Polygon';
export type { PredgeDto } from './models/PredgeDto';
export type { PriceDto } from './models/PriceDto';
export type { ProjectEstateDto } from './models/ProjectEstateDto';
export type { PropertyBuildingDto } from './models/PropertyBuildingDto';
export type { Purchase } from './models/Purchase';
export type { QuestionList } from './models/QuestionList';
export type { QuestionListPerson } from './models/QuestionListPerson';
export type { RangeOfDouble } from './models/RangeOfDouble';
export type { RangeOfInt16 } from './models/RangeOfInt16';
export type { RangeOfInt32 } from './models/RangeOfInt32';
export type { RangeTagDto } from './models/RangeTagDto';
export type { RenovationAccounting } from './models/RenovationAccounting';
export type { RoomDto } from './models/RoomDto';
export type { Sale } from './models/Sale';
export type { SearchProfileArea } from './models/SearchProfileArea';
export type { SearchProfileMunicip } from './models/SearchProfileMunicip';
export type { SearchProfilePolygon } from './models/SearchProfilePolygon';
export type { SearchProfileResponseDto } from './models/SearchProfileResponseDto';
export type { SearchProfileVitecDto } from './models/SearchProfileVitecDto';
export type { SellerOnObject } from './models/SellerOnObject';
export type { Settlement } from './models/Settlement';
export type { SiteVisionNewsDto } from './models/SiteVisionNewsDto';
export type { SiteVisionNodeDto } from './models/SiteVisionNodeDto';
export { SortOrder } from './models/SortOrder';
export type { SpeculatorCheckDto } from './models/SpeculatorCheckDto';
export type { SurroundingDto } from './models/SurroundingDto';
export type { SurroundingInfo } from './models/SurroundingInfo';
export type { Suspension } from './models/Suspension';
export type { TagModel } from './models/TagModel';
export type { TechnicalInfo } from './models/TechnicalInfo';
export type { TimeSlotDto } from './models/TimeSlotDto';
export type { TimeSlotModel } from './models/TimeSlotModel';
export type { TvAndBroadbandDto } from './models/TvAndBroadbandDto';
export type { UpdateConsentDto } from './models/UpdateConsentDto';
export type { User } from './models/User';
export type { ValuationDropDto } from './models/ValuationDropDto';
export type { VentilationDto } from './models/VentilationDto';
export type { ViewingDto } from './models/ViewingDto';
export type { VitecAddress } from './models/VitecAddress';
export type { VitecAreaData } from './models/VitecAreaData';
export type { VitecCategory } from './models/VitecCategory';
export type { VitecChain } from './models/VitecChain';
export type { VitecCoordinate } from './models/VitecCoordinate';
export type { VitecEmail } from './models/VitecEmail';
export type { VitecGroup } from './models/VitecGroup';
export type { VitecIncreasedRequirement } from './models/VitecIncreasedRequirement';
export type { VitecLand } from './models/VitecLand';
export type { VitecLandlord } from './models/VitecLandlord';
export type { VitecLease } from './models/VitecLease';
export type { VitecLeasehold } from './models/VitecLeasehold';
export type { VitecOtherData } from './models/VitecOtherData';
export type { VitecParticipant } from './models/VitecParticipant';
export type { VitecPersonDto } from './models/VitecPersonDto';
export type { VitecPersonLiteDto } from './models/VitecPersonLiteDto';
export type { VitecPropertyTypeAndAreas } from './models/VitecPropertyTypeAndAreas';
export type { VitecRange } from './models/VitecRange';
export type { VitecSearchProfileCoordinate } from './models/VitecSearchProfileCoordinate';
export type { VitecSharedSpaces } from './models/VitecSharedSpaces';
export type { VitecStatus } from './models/VitecStatus';
export type { VitecTimeSlot } from './models/VitecTimeSlot';
export type { VitecUserReview } from './models/VitecUserReview';
export type { VitecViewingInfo } from './models/VitecViewingInfo';

export { AccountService } from './services/AccountService';
export { AreaService } from './services/AreaService';
export { AssetService } from './services/AssetService';
export { BookingService } from './services/BookingService';
export { ConsentService } from './services/ConsentService';
export { ContractService } from './services/ContractService';
export { EstatesService } from './services/EstatesService';
export { FormsService } from './services/FormsService';
export { MyPagesService } from './services/MyPagesService';
export { OfficeService } from './services/OfficeService';
export { OgMetaService } from './services/OgMetaService';
export { PersonDataService } from './services/PersonDataService';
export { PublicService } from './services/PublicService';
export { SearchService } from './services/SearchService';
export { SearchProfileService } from './services/SearchProfileService';
export { ServiceService } from './services/ServiceService';
export { SitemapService } from './services/SitemapService';
export { StatisticsService } from './services/StatisticsService';
export { TtService } from './services/TtService';
export { UserService } from './services/UserService';
export { VCardService } from './services/VCardService';
